import React from 'react'
import type { MobileStepperProps as MuiMobileStepperProps } from '@material-ui/core/MobileStepper'
import MuiMobileStepper from '@material-ui/core/MobileStepper'

export type MobileStepperProps = MuiMobileStepperProps

const MobileStepper = React.forwardRef<HTMLDivElement, MobileStepperProps>(function MobileStepper(props, ref) {
  return <MuiMobileStepper ref={ref} {...props} />
})

export default MobileStepper
